import React, { useEffect, useState } from 'react';
import { Row, Col, message, Button } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderTypeGroupList } from '../ducks/actions'
import { removeOrderTypeGroup, bulkRemoveOrderTypeGroups } from '../ducks/services'
import ActionButton from 'Molecules/ActionButton';
import Search from './components/Search'
import AllRoles from '../../../../routing/config/AllRoles';
import { allowed } from '../../../../routing/config/utils';
import { getListQueryItems } from 'Modules/Application/ducks/actions';
import { useTranslate } from 'Translate';

export default (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const orderTypeGroups = useSelector((state) => state.systems.orderTypeGroups);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchVal, setSearchVal] = useState(null);
  const allowedEdit = allowed([AllRoles.SYSTEM.ORDER_TYPE_GROUP], 'write');
  const allowedDelete = allowed([AllRoles.SYSTEM.ORDER_TYPE_GROUP], 'delete');
  const globalListQuery = useSelector((state) => state.global.listQueryItems);
  const i18n = useTranslate();
  const { t } = i18n;

  const colName = [
    {
      title: t("General.code"),
      dataIndex: 'code',
      key: 'code',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("General.desc"),
      dataIndex: 'desc',
      key: 'desc',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("General.status"),
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: (text, record) =>
        <div className='flex align-items-center'>
          <span className={text === "Active" ? "c-success" : "c-danger"}>
            {t(`General.${text?.toLowerCase()}`)}
          </span>
          {
            allowedEdit &&
            <Button type="link" onClick={() => onAction(record.id, text)}>
              {text === "Active" ? `(${t("General.deactivate")})` : `(${t("General.activate")})`}
            </Button>
          }
        </div>
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      render: (text, record) =>
        <ActionButton
          title="remark_type"
          btnAction1={() => navigate(`/order-type-group/${record.id}`)}
          recordId={record.id}
          onRemove={allowedDelete && onRemove}
          setLoading={props.setLoading}
          loading={props.loading}
        />
    }
  ];

  const addNew = () => navigate('/order-type-group/add');

  const btnList = [
    {
      title: t("Product.confirm_remove_select_order_type_group"),
      text: t("General.bulk_remove"),
      classes: 'red-btn text-white attendance-success',
      permit: true,
      action: () => onBulkRemove(),
    },
    {
      text: `+ ${t("Product.new_order_type_group")}`,
      classes: 'attendance-success',
      action: () => addNew(),
    },
  ];

  useEffect(() => {
    if(!globalListQuery.orderTypeGroupListQuery) {
      dispatch(getOrderTypeGroupList(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('orderTypeGroupListQuery', 1, limit, '', '', null, props.setLoading));
    } else {
      const {page, limit, sortOrder, sortColKey, searchValue} = globalListQuery.orderTypeGroupListQuery
      dispatch(getOrderTypeGroupList(page, limit, sortOrder, sortColKey, searchValue, props.setLoading));
      setPage(page);
      setLimit(limit);
      setSearchVal(searchValue);
    }
  }, []);

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getOrderTypeGroupList(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading));
      dispatch(getListQueryItems('orderTypeGroupListQuery', pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading))
    } else {
      dispatch(getOrderTypeGroupList(pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading));
      dispatch(getListQueryItems('orderTypeGroupListQuery', pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading))
    }
  }

  const onSearch = (search) => {
    setPage(1);
    if (search) {
      let searching = {};
      searching = {
        name: search.name
      };
      setSearchVal(searching);
      dispatch(getOrderTypeGroupList(1, limit, '', '', searching, props.setLoading));
      dispatch(getListQueryItems('orderTypeGroupListQuery', 1, limit, '', '', searching, props.setLoading))
    } else {
      setSearchVal(null);
      dispatch(getOrderTypeGroupList(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('orderTypeGroupListQuery', 1, limit, '', '', null, props.setLoading))
    }
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onAction = async (templateId, status) => {
    props.setLoading(true);

    const payload = {
      order_type_group_id: templateId,
      status_event: status === "Active" ? "deactivate" : "activate"
    }

    await removeOrderTypeGroup(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("System.order_type_group_status_update_success"));
        setTimeout(() => dispatch(getOrderTypeGroupList(page, limit, '', '', searchVal, props.setLoading)), 500);
        dispatch(getListQueryItems('orderTypeGroupListQuery', page, limit, '', '', searchVal, props.setLoading))
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onRemove = async (id) => {
    props.setLoading(true);

    const payload = {
      order_type_group_id: id,
      status_event: 'remove'
    }

    await removeOrderTypeGroup(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("System.order_type_group_remove_success"));
        setTimeout(() => dispatch(getOrderTypeGroupList(page, limit, '', '', searchVal, props.setLoading)), 500);
        dispatch(getListQueryItems('orderTypeGroupListQuery', page, limit, '', '', searchVal, props.setLoading))
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onBulkRemove = async () => {
    props.setLoading(true);

    const payload = {
      order_type_groups: JSON.stringify(selectedRowKeys)
    }

    await bulkRemoveOrderTypeGroups(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        rowSelection.onChange([]);
        message.success(t("System.order_type_groups_remove_success"));
        setPage(1);
        setSearchVal(null);
        setTimeout(() => dispatch(getOrderTypeGroupList(1, limit, '', '', null, props.setLoading)), 500);
        dispatch(getListQueryItems('orderTypeGroupListQuery', 1, limit, '', '', null, props.setLoading))
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onClickRow = (record) => {
    return {
      onClick: (e) => {
        if (e.target.closest(".enable-click"))
          navigate(`/order-type-group/${record.id}`)
      },
    };
  };

  return (
    <Row gutter={[10, 10]}>
      <Col span={24}>
        <HeadingChip title={t("Product.order_type_groups")} btnList={allowedEdit ? btnList : null} btnHidden={selectedRowKeys.length <= 0} />
      </Col>
      <Col span={24} className="clickRow">
        <ListCard
          onRow={onClickRow}
          Search={Search}
          onSearch={onSearch}
          searchVal={globalListQuery.orderTypeGroupListQuery?.searchValue}
          ListData={orderTypeGroups?.list?.map(x => ({ ...x, key: x.id }))}
          onChange={onTableChange}
          ListCol={colName}
          rowSelection={allowedEdit && rowSelection}
          pagination={{
            total: orderTypeGroups?.total_count,
            current: page,
            pageSize: limit
          }}
        />
      </Col>
    </Row>
  )
}